/**
 * lib/shop-prices.ts — the DISPLAY strings for the one-time shop products, in
 * one place, for every surface that shows them (2026-10-05,
 * LANE-shop-currency-default).
 *
 * Before this file the same strings were typed separately on /super-fingers,
 * /store/distance and the /store listing — and the listing showed EUR to
 * everyone. These are the strings those pages already rendered, moved here
 * unchanged; no price changed. The canonical prices (and the VAT rate behind
 * them) live in .claude/memory/reference/PRICING-CANONICAL.md; the amount a
 * buyer is charged comes from the checkout pop-up's own quote, never from here.
 *
 * Consumers: app/super-fingers/_client/SuperFingersPageClient.tsx,
 * app/store/distance/_client/DistanceCurrencyToggle.tsx,
 * app/store/_components/StoreDistanceSection.tsx.
 */
import type { ShopCurrency } from '@/lib/currency-cookie';

interface DisplayPrice {
  /** The price the buyer pays. */
  price: string;
  /** The struck reference price shown beside it. */
  reference: string;
}

/** Super Fingers e-book — whole amounts on the page (Lars, 2026-10-03). */
export const SUPER_FINGERS_DISPLAY: Record<ShopCurrency, DisplayPrice> = {
  EUR: { price: '€26', reference: '€35.00' },
  USD: { price: '$28', reference: '$39.00' },
};

/** Distance for Piano Solo — launch price + struck reference. */
export const DISTANCE_DISPLAY: Record<ShopCurrency, DisplayPrice> = {
  EUR: { price: '€18', reference: '€28' },
  USD: { price: '$20', reference: '$30' },
};
